
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import TileLayer from 'ol/layer/Tile.js';
import BingMaps from 'ol/source/BingMaps.js';
import XYZSource from 'ol/source/XYZ';
import GeoJSON from 'ol/format/GeoJSON';
import KML from 'ol/format/KML';

import Feature from 'ol/Feature';
import Point from 'ol/geom/Point';

import {unByKey} from 'ol/Observable.js';
import {easeOut} from 'ol/easing.js';

import Style from 'ol/style/Style';
import CircleStyle from 'ol/style/Circle';
import Stroke from 'ol/style/Stroke';
import Fill from 'ol/style/Fill';

import {defaults as defaultControls, Attribution} from 'ol/control.js';
import OSM from 'ol/source/OSM.js';

import olStyle from '@/openlayers/ol_style'

export default {

    // --------------------------------------
    // Parameter 地圖參數
    // --------------------------------------
    mapAttributions: [ '© AgriWeather.online, Beehive Data Technology' ],
    center_map: [ 121, 23.5 + 0.1 ],  // Default 預設為台灣中心
    zoom: 8.2,                        // Default 預設為台灣中心
    ghost_position: [999,999],


    // --------------------------------------
    // Function 地圖工具
    // --------------------------------------

    /**
     * resetMapViewPort 重設地圖位置 & 縮放 with 動畫漸進
     * 當使用者按地圖左上方 C 的按鈕後執行
     * @param {object} osm_Map - osm map 的基底 map
     */
    resetMapViewPort: function (osm_Map)
    {
        osm_Map.getView().animate({
            duration: 300,
            center: this.center_map,
            zoom: this.zoom,
        });
    },

    /**
     * previewMap 根據輸入框的數值設定地圖位置 & 縮放 with 動畫漸進
     * 當使用者在 editMode(編輯模式) 點擊預覽按鈕時執行
     * 放寬最大最小縮放值
     * @param {object} osm_Map - osm map 的基底 map
     */
    previewMap: function (osm, longitude, latitude, zoom)
    {
        osm.View.setMaxZoom( 20 );
        osm.View.setMinZoom( 2 );

        if ( longitude != undefined && latitude != undefined && zoom != undefined )
        {
            osm.Map.getView().animate({
                duration: 300,
                center: [ parseFloat( longitude ) , parseFloat( latitude ) ],
                zoom: parseFloat( zoom ),
            });
        }
    },

    /**
     * setMap_Center 設定地圖的中心點與縮放值
     * @param {object} osm - osm map 設定
     * @param {float} longitude - 經度
     * @param {float} latitude - 緯度
     * @param {float} zoom - 縮放值
     */
    setMap_Center: function (osm, longitude, latitude, zoom)
    {
        if ( longitude != undefined && latitude != undefined && zoom != undefined )
        {
            this.center_map = [ parseFloat( longitude ) , parseFloat( latitude ) ]; // [ 經度, 緯度 ]
            this.zoom = parseFloat( zoom );
        }
        else
        {
            this.center_map = osm.center_map;
            this.zoom = osm.zoom;
        }

        // 根據畫面上的地圖寬度，動態調整縮放值
        let mapWidth = document.getElementById( osm.target ).clientWidth;
        if ( mapWidth < 900 )
        {
            // console.log('mapWidth');
            // console.log(mapWidth);
            this.zoom = this.zoom - ( 900 - mapWidth ) * 0.0035
        }

        osm.View.setMaxZoom( zoom + osm.zoom_max );
        osm.View.setMinZoom( this.zoom - osm.zoom_min );
        this.resetMapViewPort( osm.Map );
    },


    /**
     * 設定 OpenLayers 地圖基底使用什麼底圖
     * @param {string} [type='D'] - 地圖基底的樣式，預設為 OpenLayer 的底圖
     */
    setOSM_BaseMap: function (type = 'Default')
    {
        let osm_BasicMap = new TileLayer ();

        if (type == 'Default')
        {
            osm_BasicMap = new TileLayer ({
                source: new OSM (),
                attributions: this.mapAttributions,
            });
        }
        else if (type == 'GoogleMap')
        {
            //let API_Key = 'AIzaSyAXcWar6xV5yhM6vBOQoWJcf_tBIXxJpao';

            osm_BasicMap = new TileLayer ({
                title: 'Google Maps Uydu',
                type: 'base',
                visible: true,
                opacity: 1.0,//0.8,
                source: new XYZSource ({
                    attributions: this.mapAttributions,
                    url: 'https://mt0.google.com/vt/lyrs=y&hl=en&x={x}&y={y}&z={z}&s=Ga'
                })
            })

        }
        else if (type == 'BingMap')
        {
            osm_BasicMap = new TileLayer ({
                source: new BingMaps ({
                    attributions: this.mapAttributions,
                    imagerySet: 'Aerial',
                    key: 'Ao74EwxtVxpdYQOtDVP0aV8teToWY0vh68X-bcHcC134bCxGe1Kb8u2bLulVOIuD'//'Your Bing Maps Key from http://www.bingmapsportal.com/'
                })
            });
        }
        else if (type == 'BaiduMap')
        {

        }
        return osm_BasicMap
    },


    /**
     * 將傳入的圖層照順序加再地圖基底後，回傳圖層 array
     * @param {boolean} bShow_osmBasicMap - 是否要顯示底圖 (預設顯示 google map 衛星圖)
     * @param {array} [Layers=[]] - 地圖基底圖層，預設為空 array
     */
    setOSM_MapLayers: function (Show_BasicMapType, Layers = [])
    {
        let _layers = [];

        if ( Show_BasicMapType != undefined )
        {
            _layers.push( this.setOSM_BaseMap( Show_BasicMapType ) );
        }

        return _layers.concat( Layers );
    },


    /**
     * 根據 bShow_osmBasicMap 來切換 [ 街道圖 / Google 衛星圖 ]
     * @param {boolean} bShow_osmBasicMap - 是否要顯示底圖 (預設顯示 google map 衛星圖)
     * @param {array} [Layers=[]] - 地圖基底圖層，預設為空 array
     */
    switchOSM_MapLayers: function (Show_BasicMapType)
    {
        if ( Show_BasicMapType != undefined )
        {
            return this.setOSM_BaseMap( Show_BasicMapType );
        }
        return undefined
    },


    /**
     * 使用座標產生裝置點點，根據裝置分類，繪製不同顏色的點
     * @param {object} device - 裝置基本資訊物件： nickname, hashid, type, longitude, latitude
     */
    createDeviceFeature: function (device, user_Admin, editMode = false)
    {
        let _feature = new Feature ({
            name:           device.nickname,
            type:           device.type,
            status:         device.status,
            visualization:  device.visualization,
        });
        _feature.setId( device.hashid );

        // console.log(_feature.getId());
        // console.log(device.type);
        // console.log(device.nickname);
        // console.log( [ device.longitude, device.latitude ] );
        let _checkDrawable = false
        let _device_coordinate = this.ghost_position;

        if (device.longitude && device.latitude)
        {
            device.coordinates = [ device.longitude, device.latitude ]
            _device_coordinate = [ device.longitude, device.latitude ]
            _checkDrawable = true
        }
        else if (editMode)
        {
            _checkDrawable = true
        }

        if (_checkDrawable)
        {
            // 設定圖形
            let _theCoordinates = _device_coordinate;
            let _newGeom = new Point ( _theCoordinates );
            _feature.setGeometry( _newGeom );

            // 設定顯示文字座標
            // let _labelCoordinates = _device_coordinate;
            // let _labelGeom = new Point ( _labelCoordinates );
            // _feature.set( 'labelPoint', _labelGeom );

            // 設定樣式
            let _theStyle = olStyle.style_mapDevice( device.type );
            let _deviceText = '';
            if (user_Admin)
            {
                _deviceText = device.hashid;
                if ( device.nickname && device.nickname != '' )
                {
                    _deviceText += ' ' + device.nickname;
                }
            }
            else if ( device.nickname && device.nickname != '' )
            {
                _deviceText = device.nickname;
            }
            else { _deviceText = device.hashid; }

            _theStyle.getText().setText( _deviceText );
            _theStyle.getText().setOffsetX( 10 );
            _theStyle.getText().setOffsetY( Math.random() * 10 );
            _theStyle.getText().setTextAlign('left');

            _feature.setStyle( _theStyle );
        }

        return _feature;
    },


    /**
     * 將所有 gateway 與所包含的所有感測裝置繪製在地圖上
     * @param {boolean} [animate=false] -
     * @param {object} osm - osm map 設定
     * @param {object} deviceLayer - osm 的感測器 Vector Layer
     * @param {array} gatewayList - gateway 清單
     */
    setAllDeviceFeature: function (osm, deviceLayer, display_devices, user_Admin, editMode = false, animate = false)
    {
        let _source = deviceLayer.getSource();
        _source.clear();

        if ( display_devices != undefined )
        {
            display_devices.forEach( _device => {

                _source.addFeature( this.createDeviceFeature( _device, user_Admin, editMode ) );

            });
        }
        // else
        // {
        //     gatewayList.forEach( _gateway => {

        //         _gateway.type = 'gateway';
        //         _source.addFeature( this.createDeviceFeature( _gateway, user_Admin, editMode ) );

        //         _gateway.devices.forEach ( _device => {
        //             _source.addFeature( this.createDeviceFeature( _device, user_Admin, editMode ) );
        //         });
        //     });
        // }


        //if (animate) window.setInterval( this.flashDevices( osm.Map, deviceLayer ), 3000 );
        if (animate) this.flashDevices( osm.Map, deviceLayer );
    },


    /**
     * 設定裝置的炫泡傳輸光波 style
     * @param {object} osm_Map - osm map 的基底 map
     * @param {object} theMapLayer - 要繪製炫泡傳輸光波的 osm Vector Layer
     */
    flashDevices: function (osm_Map, theMapLayer)
    {
        // console.log( 'flash!!' );
        // 加上動畫
        let _duration = 3000;
        function flash (feature) {
            let _start = new Date().getTime();
            let _listenerKey;
            let _strokeColor = olStyle.color_red;//[255, 0, 0];
            let _fillColor   = olStyle.color_red;//[255, 0, 0];

            function animate(event) {
                let _vectorContext = event.vectorContext;
                let _frameState   = event.frameState;
                let _flashGeom    = feature.getGeometry().clone();
                let _elapsed      = _frameState.time - _start;
                let _elapsedRatio = _elapsed / _duration;
                // radius will be 5 at start and 30 at end.
                let _radius = easeOut( _elapsedRatio ) * 25 + 5;
                let _opacity = easeOut( 1 - _elapsedRatio );

                let _style = new Style ({
                    image: new CircleStyle ({
                            radius: _radius,
                            snapToPixel: false,
                            stroke: new Stroke ({
                                color: [ _strokeColor[0], _strokeColor[1], _strokeColor[2], _opacity * 0.4 ],
                                width: 0.25 + _opacity * 0.4
                            }),
                            fill: new Fill ({
                                color: [ _fillColor[0], _fillColor[1], _fillColor[2], _opacity * 0.2 ],
                            })
                    })
                });

                _vectorContext.setStyle( _style );
                _vectorContext.drawGeometry( _flashGeom );

                if ( _elapsed > _duration ) {
                    unByKey( _listenerKey );
                    return;
                }
                // tell OpenLayers to continue postcompose animation
                osm_Map.render();
            }
            _listenerKey = osm_Map.on('postcompose', animate);
        }


        let _source = theMapLayer.getSource();
        let _features = _source.getFeatures();

        for (let i = 0; i < _features.length; i++)
        {
            if ( _features[i].getGeometry() && _features[i].getGeometry().getType() == 'Point' )
            {
                //console.log( _features[i].getId() );
                flash( _features[i] );
            }
        }


    },

}
